import { ChildAccountStatus } from 'app/modules/user-modules/profile-modules/profile-base/interfaces/child-account/child-account-status';

export const CHILD_ACCOUNT_STATUSES = new Map<string, string>([
    [ChildAccountStatus.Active, 'ADDITIONAL_PROFILES.TEXT.STATUS.ACTIVE'],
    [ChildAccountStatus.Invited, 'ADDITIONAL_PROFILES.TEXT.STATUS.INVITED'],
    [ChildAccountStatus.Resend, 'ADDITIONAL_PROFILES.TEXT.STATUS.RESEND'],
]);

export const MAXIMUM_ADDITIONAL_PROFILES_COUNT = 5;